import { FunctionComponent, Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { PuffLoader } from "react-spinners";

import { useLocalUserQuery } from "@helloaudio/api";
import { useAnalytics } from "@helloaudio/analytics";
import { Guarded, Header, Sidebar, Topbar } from "@helloaudio/containers";

const { loginGuard } = Guarded;

function Loading() {
  return (
    <div className="loading-container">
      <h3 style={{ textAlign: "center" }}>
        <PuffLoader color="#32325d" size={150} aria-label="Loading Spinner" data-testid="loader" />
        Loading
      </h3>
    </div>
  );
}

const CustomerIoIdentity: FunctionComponent = () => {
  const analytics = useAnalytics();
  const { data: localUser } = useLocalUserQuery();

  useEffect(() => {
    if (localUser) {
      analytics.identify(localUser.local_user_id, {
        email: localUser.last_known_email,
        name: localUser.last_known_name,
      });
      analytics.page();
    }
  }, [analytics, localUser]);

  return null;
};

const PrivateShell: FunctionComponent = () => {
  return (
    <Guarded by={[loginGuard]}>
      {/* <Suspense fallback="loading..."> */}
      <Suspense fallback={<Loading />}>
        <Topbar /> {/* Used to render navigation on smaller screens */}
        <Sidebar /> {/* Used to render navigation on larger screens */}
        <Header />
        <CustomerIoIdentity />
        <main id="ha_main" className="tw-pt-32 tw-px-4 tw-pb-4 tw-relative md:tw-ml-16 md:tw-pt-16">
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </main>
      </Suspense>
    </Guarded>
  );
};

export default PrivateShell;
